<template>
  <div class="modal light" :class="{ 'is-active': isActive }">
    <div class="modal-background"></div>
    <div class="modal-card animated zoomIn faster">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t('modals.transfer.title') }}</p>
        <button class="delete" aria-label="close" @click="closeModal"></button>
      </header>
      <section class="modal-card-body">
        <div class="box-transfer">
          <div class="from">
            <hooper
              ref="transferFrom"
              :vertical="true"
              :itemsToShow="1"
              :centerMode="true"
              class="box-slide"
              @slide="handleSlideFrom"
            >
              <slide>
                <div>
                  <div class="box-title">
                    {{ $t('modals.transfer.selectAccTxt') }}
                  </div>
                  <div class="name">
                    {{ $t('modals.transfer.transferFromTxt') }}
                  </div>
                </div>
              </slide>
              <slide data-type="WALLET">
                <div>
                  <img src="@/assets/images/wallet.png" />
                  <div class="name">{{ $t('modals.transfer.walletTxt') }}</div>
                  <div class="amount">{{ wallet.amount | numberFormat }}</div>
                </div>
              </slide>
              <slide
                v-for="(slot, index) in findSlotsActive(slots)"
                :key="index"
                :data-type="slot.code"
              >
                <div>
                  <img :src="slot.logo" />
                  <div class="name">
                    {{ slot.name }} ({{ $t('modals.transfer.bahtTxt') }})
                  </div>
                  <div class="amount">{{ slot.amount | numberFormat }}</div>
                </div>
              </slide>
              <hooper-navigation slot="hooper-addons"></hooper-navigation>
            </hooper>
          </div>
          <div class="between">
            <i class="fas fa-arrow-right"></i>
          </div>
          <div class="to">
            <hooper
              ref="transferTo"
              :vertical="true"
              :itemsToShow="1"
              :centerMode="true"
              class="box-slide"
              @slide="handleSlideTo"
            >
              <slide>
                <div>
                  <div class="box-title">
                    {{ $t('modals.transfer.selectAccTxt') }}
                  </div>
                  <div class="name">
                    {{ $t('modals.transfer.transferToTxt') }}
                  </div>
                </div>
              </slide>
              <slide data-type="WALLET">
                <div>
                  <img src="@/assets/images/wallet.png" />
                  <div class="name">{{ $t('modals.transfer.walletTxt') }}</div>
                  <div class="amount">{{ wallet.amount | numberFormat }}</div>
                </div>
              </slide>
              <slide
                v-for="(slot, index) in findSlotsActive(slots)"
                :key="index"
                :data-type="slot.code"
              >
                <div>
                  <img :src="slot.logo" />
                  <div class="name">
                    {{ slot.name }} ({{ $t('modals.transfer.bahtTxt') }})
                  </div>
                  <div class="amount">{{ slot.amount | numberFormat }}</div>
                </div>
              </slide>
              <hooper-navigation slot="hooper-addons"></hooper-navigation>
            </hooper>
          </div>
        </div>
        <form @submit.prevent="handleTransfer">
          <div class="field m-t-30">
            <label for="" class="label"
              >{{ $t('modals.amountLabel') }}
              <span class="note"
                >**{{ $t('modals.transfer.minAmountLabel') }} {{ minWithdraw }}
                {{ $t('modals.transfer.bahtTxt') }}**</span
              ></label
            >
            <div class="control has-icons-left">
              <input
                v-model="amount"
                ref="input"
                type="number"
                min="0"
                placeholder="จำนวนเงิน"
                class="input text-center"
                @click="selectAll"
                required
              />
              <span class="icon is-small is-left">
                <i class="fas fa-coins"></i>
              </span>
            </div>
          </div>
          <div class="box-button m-t-30">
            <button class="button full-50 is-light" @click="closeModal">
              {{ $t('modals.cancelBtn') }}
            </button>
            <button type="submit" class="button full-50 is-primary">
              {{ $t('modals.transfer.transferBtn') }}
            </button>
          </div>
        </form>
      </section>
    </div>
  </div>
</template>

<script>
import apiWallet from '@/api/wallet'

import _ from 'lodash'
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper'
import 'hooper/dist/hooper.css'
import i18n from '@/language'
export default {
  name: 'ModalTransfer',
  components: {
    Hooper,
    Slide,
    HooperNavigation
  },
  props: {
    isActive: {
      type: Boolean,
      default: false
    },
    wallet: {
      type: Object
    },
    slots: {
      type: Array
    }
  },
  data() {
    return {
      minWithdraw: 1,
      selectedCodeFrom: null,
      selectedCodeTo: null,
      amount: ''
    }
  },
  mounted() {
    this.$refs.transferFrom.restart()
    this.$refs.transferTo.restart()

    this.$refs.transferFrom.slideTo(0)
    this.$refs.transferTo.slideTo(0)
  },
  methods: {
    closeModal() {
      this.$emit('closeModal', null)
    },
    findSlotsActive(slots) {
      return _.filter(slots, { isActive: true })
    },
    handleSlideFrom() {
      let currentIdx = this.$refs.transferFrom.currentSlide

      if (currentIdx == 0) this.selectedCodeFrom = 'NONE'
      else if (currentIdx == 1) this.selectedCodeFrom = 'WALLET'
      else {
        const slotActive = this.findSlotsActive(this.slots)
        this.selectedCodeFrom = slotActive[currentIdx - 2].code
      }
    },
    handleSlideTo() {
      let currentIdx = this.$refs.transferTo.currentSlide

      if (currentIdx == 0) this.selectedCodeTo = 'NONE'
      else if (currentIdx == 1) this.selectedCodeTo = 'WALLET'
      else {
        const slotActive = this.findSlotsActive(this.slots)
        this.selectedCodeTo = slotActive[currentIdx - 2].code
      }
    },
    handleTransfer() {
      if (this.selectedCodeFrom === 'NONE' || this.selectedCodeTo === 'NONE')
        return this.showErrorAlert(i18n.t('modals.transfer.selectAccMsg'))

      if (this.selectedCodeFrom === this.selectedCodeTo)
        return this.showErrorAlert(i18n.t('modals.transfer.canNotTransferMsg'))

      if (this.amount < this.minWithdraw)
        return this.showErrorAlert(
          `${i18n.t('modals.transfer.minAmountMsg')} ${
            this.minWithdraw
          } ${i18n.t('modals.transfer.bahtTxt')}`
        )

      this.transfer()
    },
    async transfer() {
      let loading = this.$loading.show()

      setTimeout(async () => {
        try {
          const result = await apiWallet.transfer(
            this.selectedCodeFrom,
            this.selectedCodeTo,
            this.amount
          )
          if (result) {
            this.$emit('closeModal', true)
            this.showSuccessAlert()
          }
        } catch (error) {
          this.showErrorAlert(error)
        } finally {
          loading.hide()
        }
      }, 200)
    },
    showSuccessAlert() {
      this.$swal(
        i18n.t('modals.successMsg'),
        i18n.t('modals.transferMsg'),
        'success'
      )
    },
    showErrorAlert(text) {
      this.$swal(i18n.t('modals.errorMsg'), text, 'error')
    },
    selectAll() {
      this.$refs.input.select()
    }
  }
}
</script>

<style scoped lang="scss">
.box-transfer {
  display: flex;
  justify-content: space-around;
  align-items: center;
  border-radius: 10px;
  text-shadow: -1px -1px 0px #000, 0px -1px 0px #000, 1px -1px 0px #000,
    -1px 0px 0px #000, 1px 0px 0px #000, -1px 1px 0px #000, 0px 1px 0px #000,
    1px 1px 0px #000;
  color: #ffffff;

  .box-title {
    font-size: 20px;
  }

  .box-slide {
    height: 150px;
  }

  .from,
  .to {
    text-align: center;
    width: 45%;
    // background: $primary;
    background: url('/images/bg-transfer.png') no-repeat;
    background-size: 100% 100%;
    padding: 10px 0;
    border-radius: 10px;
    max-width: 190px;

    img {
      width: auto;
      height: 60px;
    }
    .name {
      font-size: 12px;
    }
    .amount {
      font-weight: 700;
      font-size: 20px;
    }
  }
  .between {
    i {
      font-size: 40px;
      color: $primary;
    }
  }
}
.note {
  font-size: 14px;
  color: $danger;
}
</style>
